import {
  BsFiletypeJpg,
  BsFiletypePdf,
  BsFiletypePng,
} from 'react-icons/bs';

// Design Editor Export Options
export const designExportOptions = [
  {
    type: 'pdf',
    label: 'PDF',
    icon: BsFiletypePdf,
    color: 'var(--bs-red-500)',
  },
  {
    type: 'jpg',
    label: 'JPEG',
    icon: BsFiletypeJpg,
    color: 'var(--bs-pink-500)',
  },
  {
    type: 'png',
    label: 'PNG',
    icon: BsFiletypePng,
    color: 'var(--bs-orange-500)',
  },
];

// Email Editor Export Options
export const emailExportOptions = [
  {
    type: 'mjml',
    label: 'Export MJML',
  },
  {
    type: 'html',
    label: 'Export HTML',
  },
  {
    type: 'json',
    label: 'Export JSON',
  },
];

// Admin-only email export options (includes full preview)
export const adminEmailExportOptions = [
  {
    type: 'mjml',
    label: 'Export MJML',
  },
  {
    type: 'html',
    label: 'Export HTML',
  },
  {
    type: 'json',
    label: 'Export JSON',
  },
  {
    type: 'fullPreview',
    label: 'Export Full Preview',
    description: 'Export with all sample data processed (Admin only)',
  },
];

// Factory function to get options by editor type
export const getExportOptions = (editorType, isAdmin = false) => {
  switch (editorType) {
    case 'design':
      return designExportOptions;
    case 'email':
      return isAdmin ? adminEmailExportOptions : emailExportOptions;
    default:
      return [];
  }
};
